export enum ContentPosition {
    Center = 'center',
    Left = 'start',
    Right = 'end'
}
